import { render, staticRenderFns } from "./WorkflowBackground.vue?vue&type=template&id=76ea97e2&"
import script from "./WorkflowBackground.vue?vue&type=script&lang=ts&"
export * from "./WorkflowBackground.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports